/* ==========================================================================
   OMS Product Details Tabs & Independent Reviews Section V2 JS
   Theme Asset: product-tabs-v2.js
   ========================================================================== */

(() => {
  // Both V2 sections load this shared asset. Initialise it only once per page.
  if (window.omsProductTabsV2Loaded) return;
  window.omsProductTabsV2Loaded = true;

  function getComponents(root, selector) {
    const components = [];

    if (root.matches && root.matches(selector)) components.push(root);
    if (root.querySelectorAll) components.push(...root.querySelectorAll(selector));

    return components;
  }

  function initProductTabsV2(root = document) {
    getComponents(root, '.oms-pdp-tabs-v2').forEach(tabGroup => {
      const tabItems = Array.from(tabGroup.querySelectorAll('.tab-v2-item'));
      const tabPanels = Array.from(tabGroup.querySelectorAll('.tab-v2-panel'));

      const activateTab = item => {
        const targetId = item.getAttribute('data-tab');

        tabItems.forEach(tab => {
          const isSelected = tab === item;
          tab.classList.toggle('active', isSelected);
          tab.setAttribute('aria-selected', String(isSelected));
          tab.setAttribute('tabindex', isSelected ? '0' : '-1');
        });

        tabPanels.forEach(panel => {
          panel.classList.toggle('active', panel.id === targetId);
        });
      };

      tabItems.forEach((item, index) => {
        if (item.dataset.tabsV2Bound === 'true') return;
        item.dataset.tabsV2Bound = 'true';

        item.addEventListener('click', () => activateTab(item));
        item.addEventListener('keydown', event => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            activateTab(item);
            return;
          }

          let nextIndex;
          if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabItems.length;
          if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabItems.length) % tabItems.length;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = tabItems.length - 1;

          if (nextIndex !== undefined) {
            event.preventDefault();
            tabItems[nextIndex].focus();
            activateTab(tabItems[nextIndex]);
          }
        });
      });
    });
  }

  function initMobileAccordionsV2(root = document) {
    getComponents(root, '.oms-pdp-tabs-v2').forEach(tabGroup => {
      const accordionTriggers = tabGroup.querySelectorAll('.accordion-v2-trigger');
      const tabItems = tabGroup.querySelectorAll('.tab-v2-item');
      const tabPanels = tabGroup.querySelectorAll('.tab-v2-panel');

      accordionTriggers.forEach(trigger => {
        if (trigger.dataset.accordionV2Bound === 'true') return;
        trigger.dataset.accordionV2Bound = 'true';

        trigger.addEventListener('click', () => {
          const currentPanel = trigger.closest('.tab-v2-panel');
          if (!currentPanel) return;

          const willOpen = !trigger.classList.contains('active');
          trigger.classList.toggle('active', willOpen);
          trigger.setAttribute('aria-expanded', String(willOpen));

          // Keep a single desktop selection while mobile drawers remain independent.
          if (willOpen) {
            const targetId = currentPanel.id;

            tabItems.forEach(tab => {
              const isSelected = tab.getAttribute('data-tab') === targetId;
              tab.classList.toggle('active', isSelected);
              tab.setAttribute('aria-selected', String(isSelected));
              tab.setAttribute('tabindex', isSelected ? '0' : '-1');
            });

            tabPanels.forEach(panel => {
              panel.classList.toggle('active', panel === currentPanel);
            });

            setTimeout(() => {
              trigger.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
            }, 50);
          }
        });
      });
    });
  }

  function initProductPageV2(root = document) {
    initProductTabsV2(root);
    initMobileAccordionsV2(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initProductPageV2(), { once: true });
  } else {
    initProductPageV2();
  }

  // Shopify's theme editor can replace sections without reloading the document.
  document.addEventListener('shopify:section:load', event => initProductPageV2(event.target));
})();
